import CryptoJS from "crypto-js";

export const encryptPassword = (password) => {
const secretKey = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImZfWmIx";

    // Asegurarse de que la clave tenga exactamente 16 bytes (128 bits)
    const key = CryptoJS.enc.Utf8.parse(secretKey.slice(0, 16)); // Recorta a 16 caracteres si es necesario

    const encrypted = CryptoJS.AES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,    // Modo ECB
        padding: CryptoJS.pad.Pkcs7 // Padding PKCS7
    }).toString();

    return encrypted;
};

/*
// Funci�n para encriptar la contrase�a
function encryptPassword(password) {
    // Clave secreta que se usar� tanto en el front-end como en el back-end
    const secretKey = "clave_secreta_123";

    // Encriptar la contrase�a utilizando AES
    const encrypted = CryptoJS.AES.encrypt(password, secretKey).toString();
    
    // Devolver la contrase�a encriptada
    return encrypted;
}
*/